import {IOrdinazioneSimple} from "../interfaces/cliente/ordine";
import Ordine from "../mapper/Ordine";
import {db} from "../script/Fetch";
import FirestoreDbQueries from "./FirestoreDbQueries";

export default class OrdineDbQueries extends FirestoreDbQueries<Ordine> {
    listener: { [key: string]: (() => void); } = {};
    ordineListByClienteId: { [clienteId: string]: { [ordineId: string]: Ordine; }; } = {};

    startListenOrdiniByClienteId(clienteId: string) {
        this.listener[clienteId] = db.collection("clienti")
            .doc(clienteId)
            .collection("ordini")
            .onSnapshot(snapshot => {
                for (let change of snapshot.docChanges()) {
                    if (this.ordineListByClienteId[clienteId] === undefined) {
                        this.ordineListByClienteId[clienteId] = {};
                    }

                    this.ordineListByClienteId[clienteId][change.doc.id] = this.convertFromFirestore(change.doc.id, change.doc.data());
                }
                this.notify();
            });
    }

    stopListenOrdini(clienteId: string) {
        if (this.listener === undefined) {
            return;
        }
        this.listener[clienteId]();
    }

    notify(): void {
        this.instances.forEach(instance => {
            instance.updateOrdiniByClienteId(this.ordineListByClienteId);
        });
    }

    async updateOrdine(clienteId: string, ordineId: string, ordine: IOrdinazioneSimple) {
        db.collection("clienti").doc(clienteId).collection("ordini").doc(ordineId).set(ordine);
    }

    async updateByClienteIdAndOrdine(clienteId: string, ordine: Ordine) {
        let ordineFirestore = this.convertToFirestore(ordine);
        console.log(ordineFirestore);
        db.collection("clienti").doc(clienteId).collection("ordini").doc(ordine.documentId).update(ordineFirestore);
    }

    convertFromFirestore(documentId: string, mapperObject: any): Ordine {
        return Ordine.convertFromFirestore(documentId, mapperObject);
    }

    convertToFirestore(mapperObject: Ordine): firebase.firestore.DocumentData {
        return Ordine.convertToFirestore(mapperObject);
    }

}